const CDN_BASE = "https://imagedelivery.net/PGazI22rkoVq3pi7i0n0-g";

export const images = {
  impala: `${CDN_BASE}/7a2ed889-42c0-4091-01cb-1ae72cfc9b00/1920x1080`,
  protest: `${CDN_BASE}/a36061f0-d74d-4817-c954-540d1f3c8900/1920x1080`,
  sellElectricityMobile: `${CDN_BASE}/97fa18a0-3932-49b4-05e2-352c1f309a00/1920x1080`,
  sellElectricity: `${CDN_BASE}/ae084aa6-77ae-4abf-6297-0f05c3f36400/1920x1080`,
  sellElectricityPage: `${CDN_BASE}/05f7b07f-b6c4-4f6d-7ee6-677e44cbc000/1920x1080`,
  callCenter: `${CDN_BASE}/ae23acbc-5b9c-47e5-5b6d-59a60d162500/1920x1080`,
  engineer: `${CDN_BASE}/983b4f7c-918b-48ea-db61-66e991179200/1920x1080`,
  funnyInvoice: `${CDN_BASE}/bdf3b925-6e79-4f1c-6ba3-27c9c2ed7e00/1920x1080`,
  excavator: `${CDN_BASE}/47a3c6f9-6476-4c3d-64f3-b4eeb793b000/1920x1080`,
  bild3: `${CDN_BASE}/5d6d27bb-e085-4f5f-c665-02cc48537000/1920x1080`,
  bild2: `${CDN_BASE}/8fb0a0ee-caad-403f-2a30-fda390c74900/1920x1080`,
  bild1: `${CDN_BASE}/5ea82e5b-fed2-46b1-374a-40d7241af300/1920x1080`,
  shower: `${CDN_BASE}/7029f8f3-074e-4ec1-5f42-4df6e4bde800/1920x1080`,
  wire: `${CDN_BASE}/d514298f-dd43-43ac-64fd-53ca636ca200/1920x1080`,
  callFooter: `${CDN_BASE}/2267999d-d20f-4f23-a2fd-852a12c90700/1920x1080`,
  turtle: `${CDN_BASE}/350a1c7e-6381-444d-37c7-0381c5c9b900/1920x1080`,
  hero: `${CDN_BASE}/b5a5fadf-3905-4b65-fb8e-bb757bbe9800/1920x1080`,

  campaignDesktop: `${CDN_BASE}/46d1387b-a01e-4b2d-f4de-9717a65e0f00/1920x1080`,
  campaignMobile: `${CDN_BASE}/8cffd120-a075-4b20-41ee-05a405213200/1024x768`,

  campaignChipsMobile: `${CDN_BASE}/995bd880-4bc6-4ad2-58f8-a1272c8dcd00/1920x1080`,
  campaignChipsTablet: `${CDN_BASE}/9dd4405b-1b74-4d63-728b-2ea8df507100/1024x768`,
  campaignChipsDesktop: `${CDN_BASE}/74f318e8-d23a-4c80-0561-e2f0f3f35100/1920x1080`,

  campaignStegraDesktop: `${CDN_BASE}/ac96d72a-8262-4d15-9673-76ffbf8eb300/1920x1080`,
  campaignStegraMobile: `${CDN_BASE}/4a64afb0-cc81-4779-018d-1dfd9d0d6800/public`,
  campaignStegraRose: `${CDN_BASE}/8d203b5e-292c-4cd3-6b36-0b8d0be97100/public`,

  earthHourMobile: `${CDN_BASE}/37415188-55d2-4996-2a02-f1818224b700/1024x768`,
  earthHourDesktop: `${CDN_BASE}/37415188-55d2-4996-2a02-f1818224b700/public`,
  earthHourSocial: `${CDN_BASE}/1faff3e9-9b12-4e0c-d5b0-409ff14cf800/public`,
};
